

import React, { useState, useRef, useCallback, RefObject } from 'react';
import { Grid, makeStyles, Theme, Box, Card, useMediaQuery, Button, Typography, ThemeProvider } from '@material-ui/core'
import DropZone from '../DropZone/DropZone'
import UploadImageButtons from '../UploadImageButtons/UploadImageButtons'
import Webcam from "react-webcam";
import useDidMountEffect from '../../hooks/useDidMountEffect'
import MobileWebcam from '../MobileWebcam/MobileWebcam'
import { useTranslation } from 'react-i18next'
import theme from 'js/material-ui-theme';
import { IdhaDialogs, useDialog } from '@idha/sanitization-components';
//import { appModule } from 'modules/app/app-module';

export interface FileProps {
  preview: string,
  file: File | Blob
}

export interface UploadImageProps {
  updateSwipeableView?: () => void,
  onUploadAgronomistSignature?: (signatureFile: File | Blob) => void,
  signatureImageUrl?: string,
  setDeleteCurrentSignature?: (deleteCurrent: boolean) => void
  deleteCurrentSignature?: boolean,
  setChangeCurrentSignature?: (changeCurrent: boolean) => void,
  changeCurrentSignature?: boolean,
  selectedImage?: FileProps,
  setSelectedImage?: (selectedFile: FileProps) => void,
  uploadTitle?: string
}


const useStyles = makeStyles((theme: Theme) => ({
  responsiveImg: {
    maxWidth: "100%"
  },
  containerImage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  uploadContainer: {
    width: "100%"
  },
  buttonsSignature: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: `${theme.spacing(2)}px`
  },
  signatureButtons: {
    margin: `${theme.spacing(2)}px`,
    marginTop: `${theme.spacing(6)}px`,
    marginBottom: `${theme.spacing(6)}px`
  },
  signatureTitle: {
    margin: `${theme.spacing(2)}px`,
    marginTop: `${theme.spacing(6)}px`,
    marginBottom: `${theme.spacing(6)}px`,
    width: "100%",
    textAlign: "center"
  },
  warningBox: {
    backgroundColor: `#ff5722`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: `${theme.spacing(3)}px`,
    margin: `${theme.spacing(3)}px`,

  }
}))
const videoConstraints = {
  width: 320,
  height: 200,
  facingMode: "user"
};



const UploadImage: React.FC<UploadImageProps> = ({ updateSwipeableView, onUploadAgronomistSignature, signatureImageUrl, deleteCurrentSignature, setDeleteCurrentSignature, changeCurrentSignature, setChangeCurrentSignature, selectedImage, setSelectedImage, uploadTitle }) => {

  const [cameraRecording, setCameraRecording] = useState(false)
  const webcamRef = useRef(null)
  const cellphoneScreen = useMediaQuery('(max-width:460px)');
  const { responsiveImg, uploadContainer, buttonsSignature, signatureButtons, signatureTitle, warningBox, containerImage } = useStyles()
  const { t } = useTranslation(["FileUpload"])
  const [dlgProps, dialog] = useDialog();
  useDidMountEffect(() => {

    updateSwipeableView && updateSwipeableView()
  }, [cameraRecording, cellphoneScreen, selectedImage, deleteCurrentSignature, changeCurrentSignature, signatureImageUrl])



  const onCapture = (webcanRef: RefObject<Webcam> = webcamRef) => {
    const imageSrc = webcanRef.current.getScreenshot();
    setSelectedImage({
      file: dataURLtoBlob(imageSrc),
      preview: imageSrc,
    });
    setCameraRecording(false);
  };

  const dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  function createFileObject(file: File) {
    return {
      file,
      preview: URL.createObjectURL(file),
    }
  }
  function onSelectFile(file: File) {
    validateFile(file)
  }
  function onCancel() {
    setSelectedImage(undefined)
  }

  const validateFile = (file: File) => {

    const typeFile = file?.type.split('/')[1]
    
    if(typeFile){
        if(!['png', 'jpeg', 'jpg'].find(f => f == typeFile)){
            dialog
            .confirm('')
            .withMessage(t("bad_content_dialog.content", {
                fileformat: "png ou jpeg",
            }))
            .withConfirmLabel('OK')
            .onConfirm(() => setSelectedImage(undefined))
            .show()
        } else if (file?.size/2e6 > 0.999999) {
            dialog
            .confirm('')
            .withMessage(t("bad_content_dialog.file_to_large", {
                maxSize: "2MB",
            }))
            .withConfirmLabel('OK')
            .onConfirm(() => setSelectedImage(undefined))
            .show()
        }else{
          setSelectedImage(createFileObject(file))
        }
    } else{
      setSelectedImage(undefined)
    }
}

  function renderCamera() {
    return <Webcam
      ref={webcamRef}
      videoConstraints={videoConstraints}
      audio={false}
      screenshotFormat="image/jpeg"
    />
  }
  function renderImage() {
    return <img style={{ height: "240px" }} src={selectedImage.preview} />
  }

  const uploadFile = useCallback(() => {
    selectedImage && onUploadAgronomistSignature(selectedImage.file)
  }, [selectedImage])

  const handleWantsChangeCurrentSignature = useCallback(() => {
    setChangeCurrentSignature(true)
  }, [setChangeCurrentSignature])

  const handleWantDeleteCurrentSignature = useCallback(() => {
    setDeleteCurrentSignature(true)
  }, [setDeleteCurrentSignature])


  return <ThemeProvider theme={theme}>

    <div className={uploadContainer}>
      {signatureImageUrl && !changeCurrentSignature ?
        <div>
          <Grid container spacing={2} alignItems={"center"} justify="center" >
            <Grid item md={6} sm={12} xs={12}  >
              <Card elevation={!cellphoneScreen ? 1 : 0}>
                <Box>
                  <Typography className={signatureTitle} color={"textSecondary"}>
                    {uploadTitle}
                  </Typography>
                  {deleteCurrentSignature ? (
                    <div className={warningBox}>
                      <Typography color="textSecondary">{t("confirm_exclude")}</Typography>
                    </div>
                  ) :
                    (<div>
                      <Box className={containerImage} paddingX={!cellphoneScreen ? 12 : 0}>
                        <img src={signatureImageUrl} width={videoConstraints.width} height={videoConstraints.height} className={responsiveImg} alt="Agronomist Signature" />
                      </Box>
                      <div className={buttonsSignature}>
                        <Button className={signatureButtons} onClick={handleWantDeleteCurrentSignature} >
                          <Typography color="error">{t("exclude")}</Typography>
                        </Button>
                        <Button className={signatureButtons} onClick={handleWantsChangeCurrentSignature}>
                          <Typography color="primary">
                            {t("send_another")}
                          </Typography>
                        </Button>
                      </div>
                    </div>)
                  }
                </Box>
              </Card>
            </Grid>
          </Grid></div> :
        <Grid container spacing={2} alignItems={"center"} justify="center" >
          <Grid item md={6} sm={12} xs={12}>
            {
              cellphoneScreen && !selectedImage ? null :
                <DropZone
                  imageConstrant={{
                    height: videoConstraints.height,
                    width: videoConstraints.width
                  }}
                  onDropFile={onSelectFile}
                  contentComponet={cameraRecording ? renderCamera() : selectedImage ? renderImage() : undefined

                  }
                />
            }
          </Grid>
          {
            cameraRecording && cellphoneScreen ?
              <Grid item xs={12} >
                <MobileWebcam handleOnCapture={onCapture} onCancel={() => setCameraRecording(false)} />
              </Grid> :
              <Grid item md={6} sm={12} xs={12} >
                <UploadImageButtons {...{ cameraRecording, setCameraRecording, onCapture, onSelectFile, onCancel, hasFileSelected: selectedImage ? true : false, uploadFile }} />
              </Grid>
          }
        </Grid>}
    </div>
    <IdhaDialogs {...dlgProps} />
  </ThemeProvider>



}

export default UploadImage;

//appModule.value('UploadImage',UploadImage);
